module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[9]8.0423df8.woff2";